// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1RQLV","title":"FrontImage_title__1-ekP"};